import { Globe, Truck } from '@dhl/illustrations'

import { Sx } from '@dhl/theme'
import { CARRIER } from '~/basket/model/constants'

const classes: Record<string, Sx> = {
  icon: (theme) => ({
    [theme.breakpoints.down('sm')]: {
      width: '120px',
      height: '80px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '150px',
      height: '100px',
    },
  }),
}

type Props = {
  carrierKey: string
}

export const CarrierIcon = ({ carrierKey }: Props) => {
  switch (carrierKey) {
    case CARRIER.PARCEL:
      return <Truck viewBox="0 0 255 170" sx={classes.icon} />
    case CARRIER.EXPRESS:
      return <Globe viewBox="0 0 255 179" sx={classes.icon} />
    case CARRIER.EXPRESS_ECONOMY:
      return <Truck viewBox="0 0 255 170" sx={classes.icon} />
    default:
      throw new Error(`Unknown carrier key ${carrierKey}`)
  }
}
